import React, { useContext } from 'react';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import colors from 'styles/colors';
import styled from 'styled-components';

import Alert from './components/Alert';

const AlertConstrain = styled.div`
  background-color: ${colors.primary.ice};
  position: relative;
  z-index: 1;
`;

/**
 * Alert component
 *
 */

const Alerts = () => {
  const { alerts } = useContext(CruiseSearchContext);

  if (!alerts || alerts.length === 0) return null;

  return (
    <AlertConstrain>
      {alerts?.length > 0 &&
        alerts.map(alert => (
          <Alert
            key={`${alert.title}-container`}
            title={alert.title}
            description={alert.description}
            link={alert.link}
          />
        ))}
    </AlertConstrain>
  );
};

export default Alerts;
